<div class="confirmation-holder">
  <!-- <ion-toolbar color="primary"> -->
  <h4>Confirm Action</h4>
  <!-- </ion-toolbar> -->
</div>

<mat-grid-list [cols]="1">
  <p class="text text-align-center">
    {{ confimationMessage }}
  </p>
  <div class="center-column">
    <div class="wrapper center-column">
      <huge-row class="mat-margin-top mat-align-items-center">
        <mat-col>
          <button class="btn primary-btn" expand="full" (click)="closeModal(true)">Confirm</button>

          <p (click)="closeModal(false)" class="close-modal-text text-align-center"> Cancel </p>
        </mat-col>
      </huge-row>
    </div>
  </div>
</mat-grid-list>